/* eslint-disable prettier/prettier */
/* eslint-disable import/order */

import { registry } from "@nextgisweb/jsrealm/entrypoint/registry";

export * from "@nextgisweb/jsrealm/entrypoint/registry";

// JSRealm entries

registry.register("audit", {
    identity: "@nextgisweb/audit/journal",
    value: () => import("@nextgisweb/audit/journal"),
});

registry.register("auth", {
    identity: "@nextgisweb/auth/group-browse",
    value: () => import("@nextgisweb/auth/group-browse"),
});

registry.register("auth", {
    identity: "@nextgisweb/auth/group-widget",
    value: () => import("@nextgisweb/auth/group-widget"),
});

registry.register("auth", {
    identity: "@nextgisweb/auth/session-invite",
    value: () => import("@nextgisweb/auth/session-invite"),
});

registry.register("auth", {
    identity: "@nextgisweb/auth/settings-form",
    value: () => import("@nextgisweb/auth/settings-form"),
});

registry.register("auth", {
    identity: "@nextgisweb/auth/store",
    value: () => import("@nextgisweb/auth/store"),
});

registry.register("auth", {
    identity: "@nextgisweb/auth/user-browse",
    value: () => import("@nextgisweb/auth/user-browse"),
});

registry.register("auth", {
    identity: "@nextgisweb/auth/user-widget",
    value: () => import("@nextgisweb/auth/user-widget"),
});

registry.register("basemap", {
    identity: "@nextgisweb/basemap/layer-widget",
    value: () => import("@nextgisweb/basemap/layer-widget"),
});

registry.register("basemap", {
    identity: "@nextgisweb/basemap/plugin/base-map",
    value: () => import("@nextgisweb/basemap/plugin/base-map"),
});

registry.register("basemap", {
    identity: "@nextgisweb/basemap/webmap-widget",
    value: () => import("@nextgisweb/basemap/webmap-widget"),
});

registry.register("cadaster", {
    identity: "@nextgisweb/cadaster/cadaster-settings",
    value: () => import("@nextgisweb/cadaster/cadaster-settings"),
});

registry.register("cadaster", {
    identity: "@nextgisweb/cadaster/webmap/plugin",
    value: () => import("@nextgisweb/cadaster/webmap/plugin"),
});

registry.register("collector", {
    identity: "@nextgisweb/collector/collector-user-browse",
    value: () => import("@nextgisweb/collector/collector-user-browse"),
});

registry.register("collector", {
    identity: "@nextgisweb/collector/collector-user-editor",
    value: () => import("@nextgisweb/collector/collector-user-editor"),
});

registry.register("collector", {
    identity: "@nextgisweb/collector/resource-items",
    value: () => import("@nextgisweb/collector/resource-items"),
});

registry.register("collector", {
    identity: "@nextgisweb/collector/resource-project",
    value: () => import("@nextgisweb/collector/resource-project"),
});

registry.register("collector", {
    identity: "@nextgisweb/collector/resource-users",
    value: () => import("@nextgisweb/collector/resource-users"),
});

registry.register("feature_attachment", {
    identity: "@nextgisweb/feature-attachment/attachment-bundle/plugin",
    value: () => import("@nextgisweb/feature-attachment/attachment-bundle/plugin"),
});

registry.register("feature_attachment", {
    identity: "@nextgisweb/feature-attachment/attachment-form",
    value: () => import("@nextgisweb/feature-attachment/attachment-form"),
});

registry.register("feature_layer", {
    identity: "@nextgisweb/feature-layer/export-form",
    value: () => import("@nextgisweb/feature-layer/export-form"),
});

registry.register("feature_layer", {
    identity: "@nextgisweb/feature-layer/feature-display",
    value: () => import("@nextgisweb/feature-layer/feature-display"),
});

registry.register("feature_layer", {
    identity: "@nextgisweb/feature-layer/feature-editor",
    value: () => import("@nextgisweb/feature-layer/feature-editor"),
});

registry.register("feature_layer", {
    identity: "@nextgisweb/feature-layer/feature-grid",
    value: () => import("@nextgisweb/feature-layer/feature-grid"),
});

registry.register("feature_layer", {
    identity: "@nextgisweb/feature-layer/fields-widget",
    value: () => import("@nextgisweb/feature-layer/fields-widget"),
});

registry.register("feature_layer", {
    identity: "@nextgisweb/feature-layer/settings-widget",
    value: () => import("@nextgisweb/feature-layer/settings-widget"),
});

registry.register("file_bucket", {
    identity: "@nextgisweb/file-bucket/resource-widget",
    value: () => import("@nextgisweb/file-bucket/resource-widget"),
});

registry.register("formbuilder", {
    identity: "@nextgisweb/formbuilder/form-widget",
    value: () => import("@nextgisweb/formbuilder/form-widget"),
});

registry.register("gui", {
    identity: "@nextgisweb/gui/error",
    value: () => import("@nextgisweb/gui/error"),
});

registry.register("gui", {
    identity: "@nextgisweb/gui/react-boot",
    value: () => import("@nextgisweb/gui/react-boot"),
});

registry.register("jsrealm", {
    identity: "@nextgisweb/jsrealm/testentry/runner",
    value: () => import("@nextgisweb/jsrealm/testentry/runner"),
});

registry.register("layer_preview", {
    identity: "@nextgisweb/layer-preview/preview-layer",
    value: () => import("@nextgisweb/layer-preview/preview-layer"),
});

registry.register("lookup_table", {
    identity: "@nextgisweb/lookup-table/editor",
    value: () => import("@nextgisweb/lookup-table/editor"),
});

registry.register("mapserver", {
    identity: "@nextgisweb/mapserver/editor-widget",
    value: () => import("@nextgisweb/mapserver/editor-widget"),
});

registry.register("model_3d", {
    identity: "@nextgisweb/model-3d/editor-widget",
    value: () => import("@nextgisweb/model-3d/editor-widget"),
});

registry.register("ogcfserver", {
    identity: "@nextgisweb/ogcfserver/service-widget",
    value: () => import("@nextgisweb/ogcfserver/service-widget"),
});

registry.register("postgis", {
    identity: "@nextgisweb/postgis/connection-widget",
    value: () => import("@nextgisweb/postgis/connection-widget"),
});

registry.register("postgis", {
    identity: "@nextgisweb/postgis/diagnostics-widget",
    value: () => import("@nextgisweb/postgis/diagnostics-widget"),
});

registry.register("postgis", {
    identity: "@nextgisweb/postgis/layer-widget",
    value: () => import("@nextgisweb/postgis/layer-widget"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/backup-browse",
    value: () => import("@nextgisweb/pyramid/backup-browse"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/cors-settings",
    value: () => import("@nextgisweb/pyramid/cors-settings"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/custom-css-form",
    value: () => import("@nextgisweb/pyramid/custom-css-form"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/fonts",
    value: () => import("@nextgisweb/pyramid/fonts"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/home-path",
    value: () => import("@nextgisweb/pyramid/home-path"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/icon",
    value: () => import("@nextgisweb/pyramid/icon"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/layout",
    value: () => import("@nextgisweb/pyramid/layout"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/logo-form",
    value: () => import("@nextgisweb/pyramid/logo-form"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/metrics",
    value: () => import("@nextgisweb/pyramid/metrics"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/storage-summary",
    value: () => import("@nextgisweb/pyramid/storage-summary"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/swagger-ui",
    value: () => import("@nextgisweb/pyramid/swagger-ui"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/system-info",
    value: () => import("@nextgisweb/pyramid/system-info"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/system-name-form",
    value: () => import("@nextgisweb/pyramid/system-name-form"),
});

registry.register("pyramid", {
    identity: "@nextgisweb/pyramid/update",
    value: () => import("@nextgisweb/pyramid/update"),
});

registry.register("qgis", {
    identity: "@nextgisweb/qgis/default-style-widget",
    value: () => import("@nextgisweb/qgis/default-style-widget"),
});

registry.register("qgis", {
    identity: "@nextgisweb/qgis/raster-editor-widget",
    value: () => import("@nextgisweb/qgis/raster-editor-widget"),
});

registry.register("qgis", {
    identity: "@nextgisweb/qgis/vector-editor-widget",
    value: () => import("@nextgisweb/qgis/vector-editor-widget"),
});

registry.register("raster_layer", {
    identity: "@nextgisweb/raster-layer/editor-widget",
    value: () => import("@nextgisweb/raster-layer/editor-widget"),
});

registry.register("raster_layer", {
    identity: "@nextgisweb/raster-layer/export-form",
    value: () => import("@nextgisweb/raster-layer/export-form"),
});

registry.register("render", {
    identity: "@nextgisweb/render/legend-symbols-widget",
    value: () => import("@nextgisweb/render/legend-symbols-widget"),
});

registry.register("render", {
    identity: "@nextgisweb/render/tile-cache-widget",
    value: () => import("@nextgisweb/render/tile-cache-widget"),
});

registry.register("resmeta", {
    identity: "@nextgisweb/resmeta/editor",
    value: () => import("@nextgisweb/resmeta/editor"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/children-section",
    value: () => import("@nextgisweb/resource/children-section"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/composite",
    value: () => import("@nextgisweb/resource/composite"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/delete-page",
    value: () => import("@nextgisweb/resource/delete-page"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/description-editor",
    value: () => import("@nextgisweb/resource/description-editor"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/editor-widget",
    value: () => import("@nextgisweb/resource/editor-widget"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/effective-permissions",
    value: () => import("@nextgisweb/resource/effective-permissions"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/export-settings",
    value: () => import("@nextgisweb/resource/export-settings"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/external-access",
    value: () => import("@nextgisweb/resource/external-access"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/favorite/FavoritePage",
    value: () => import("@nextgisweb/resource/favorite/FavoritePage"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/json-view",
    value: () => import("@nextgisweb/resource/json-view"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/main-section",
    value: () => import("@nextgisweb/resource/main-section"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/permissions-widget",
    value: () => import("@nextgisweb/resource/permissions-widget"),
});

registry.register("resource", {
    identity: "@nextgisweb/resource/resources-filter",
    value: () => import("@nextgisweb/resource/resources-filter"),
});

registry.register("scene_3d", {
    identity: "@nextgisweb/scene-3d/basemaps-widget",
    value: () => import("@nextgisweb/scene-3d/basemaps-widget"),
});

registry.register("scene_3d", {
    identity: "@nextgisweb/scene-3d/items-widget",
    value: () => import("@nextgisweb/scene-3d/items-widget"),
});

registry.register("scene_3d", {
    identity: "@nextgisweb/scene-3d/settings-widget",
    value: () => import("@nextgisweb/scene-3d/settings-widget"),
});

registry.register("scene_3d", {
    identity: "@nextgisweb/scene-3d/terrains-widget",
    value: () => import("@nextgisweb/scene-3d/terrains-widget"),
});

registry.register("sentry", {
    identity: "@nextgisweb/sentry/init",
    value: () => import("@nextgisweb/sentry/init"),
});

registry.register("social", {
    identity: "@nextgisweb/social/editor-widget",
    value: () => import("@nextgisweb/social/editor-widget"),
});

registry.register("spatial_ref_sys", {
    identity: "@nextgisweb/spatial-ref-sys/catalog-browse",
    value: () => import("@nextgisweb/spatial-ref-sys/catalog-browse"),
});

registry.register("spatial_ref_sys", {
    identity: "@nextgisweb/spatial-ref-sys/catalog-import",
    value: () => import("@nextgisweb/spatial-ref-sys/catalog-import"),
});

registry.register("spatial_ref_sys", {
    identity: "@nextgisweb/spatial-ref-sys/srs-browse",
    value: () => import("@nextgisweb/spatial-ref-sys/srs-browse"),
});

registry.register("spatial_ref_sys", {
    identity: "@nextgisweb/spatial-ref-sys/srs-widget",
    value: () => import("@nextgisweb/spatial-ref-sys/srs-widget"),
});

registry.register("style_3d", {
    identity: "@nextgisweb/style-3d/style-3d-widget",
    value: () => import("@nextgisweb/style-3d/style-3d-widget"),
});

registry.register("svg_marker_library", {
    identity: "@nextgisweb/svg-marker-library/resource-widget",
    value: () => import("@nextgisweb/svg-marker-library/resource-widget"),
});

registry.register("terrain_provider", {
    identity: "@nextgisweb/terrain-provider/resource-widget",
    value: () => import("@nextgisweb/terrain-provider/resource-widget"),
});

registry.register("tileset", {
    identity: "@nextgisweb/tileset/resource-widget",
    value: () => import("@nextgisweb/tileset/resource-widget"),
});

registry.register("tileset_3d", {
    identity: "@nextgisweb/tileset-3d/editor-widget",
    value: () => import("@nextgisweb/tileset-3d/editor-widget"),
});

registry.register("tmsclient", {
    identity: "@nextgisweb/tmsclient/tmsclient-connection",
    value: () => import("@nextgisweb/tmsclient/tmsclient-connection"),
});

registry.register("tmsclient", {
    identity: "@nextgisweb/tmsclient/tmsclient-layer",
    value: () => import("@nextgisweb/tmsclient/tmsclient-layer"),
});

registry.register("tracker", {
    identity: "@nextgisweb/tracker/plugin",
    value: () => import("@nextgisweb/tracker/plugin"),
});

registry.register("tracker", {
    identity: "@nextgisweb/tracker/reports",
    value: () => import("@nextgisweb/tracker/reports"),
});

registry.register("tracker", {
    identity: "@nextgisweb/tracker/tracker-settings",
    value: () => import("@nextgisweb/tracker/tracker-settings"),
});

registry.register("tracker", {
    identity: "@nextgisweb/tracker/tracker-widget",
    value: () => import("@nextgisweb/tracker/tracker-widget"),
});

registry.register("vector_layer", {
    identity: "@nextgisweb/vector-layer/resource-widget",
    value: () => import("@nextgisweb/vector-layer/resource-widget"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/clone-webmap",
    value: () => import("@nextgisweb/webmap/clone-webmap"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/display-tiny",
    value: () => import("@nextgisweb/webmap/display-tiny"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/display/DisplayWidget",
    value: () => import("@nextgisweb/webmap/display/DisplayWidget"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/image-adapter",
    value: () => import("@nextgisweb/webmap/image-adapter"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/items-widget",
    value: () => import("@nextgisweb/webmap/items-widget"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/plugin/feature-layer",
    value: () => import("@nextgisweb/webmap/plugin/feature-layer"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/plugin/layer-editor",
    value: () => import("@nextgisweb/webmap/plugin/layer-editor"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/plugin/layer-info",
    value: () => import("@nextgisweb/webmap/plugin/layer-info"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/plugin/layer-opacity",
    value: () => import("@nextgisweb/webmap/plugin/layer-opacity"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/plugin/zoom-to-layer",
    value: () => import("@nextgisweb/webmap/plugin/zoom-to-layer"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/plugin/zoom-to-webmap",
    value: () => import("@nextgisweb/webmap/plugin/zoom-to-webmap"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/settings",
    value: () => import("@nextgisweb/webmap/settings"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/settings-widget",
    value: () => import("@nextgisweb/webmap/settings-widget"),
});

registry.register("webmap", {
    identity: "@nextgisweb/webmap/tile-adapter",
    value: () => import("@nextgisweb/webmap/tile-adapter"),
});

registry.register("wfsclient", {
    identity: "@nextgisweb/wfsclient/wfsclient-connection",
    value: () => import("@nextgisweb/wfsclient/wfsclient-connection"),
});

registry.register("wfsclient", {
    identity: "@nextgisweb/wfsclient/wfsclient-layer",
    value: () => import("@nextgisweb/wfsclient/wfsclient-layer"),
});

registry.register("wfsserver", {
    identity: "@nextgisweb/wfsserver/service-widget",
    value: () => import("@nextgisweb/wfsserver/service-widget"),
});

registry.register("wmsclient", {
    identity: "@nextgisweb/wmsclient/wmsclient-connection",
    value: () => import("@nextgisweb/wmsclient/wmsclient-connection"),
});

registry.register("wmsclient", {
    identity: "@nextgisweb/wmsclient/wmsclient-layer",
    value: () => import("@nextgisweb/wmsclient/wmsclient-layer"),
});

registry.register("wmsserver", {
    identity: "@nextgisweb/wmsserver/service-widget",
    value: () => import("@nextgisweb/wmsserver/service-widget"),
});

// Legacy @entrypoints

registry.register("custom_webmap", {
    identity: "@nextgisweb/custom-webmap/message",
    value: () => import("@nextgisweb/custom-webmap/message"),
});

registry.register("model_3d", {
    identity: "@nextgisweb/model-3d/preview-section",
    value: () => import("@nextgisweb/model-3d/preview-section"),
});

// Other


registry.seal();
